const signUpDataDefault = {
  first_name: '',
  last_name: '',
  email: '',
  confirm_email: '',
  phone: '',
  phone1: '',
  phone2: '',
  phone3: '',
  reasons_know: '',
  password: '',
  confirm_password: '',
  postal_code_en: '',
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_coupon: null,
  register: '',
  comeback: null,
  trial_free: null,
  c2p: null,
  is_corp: false,
  company_id: '',
  is_free_member: false,
  usage_period: '',
  user_type: ''
}
const state = {
  currentStepSignUp: 0,
  maxStepSignUp: 0,
  signUpData: {
    ...signUpDataDefault
  }
}

const getters = {}

const actions = {
  nextStep({ commit }, data = {}) {
    if (Object.keys(data).length) {
      commit('updateSignUpData', data)
    }
    commit('nextStep')
  },
  resetStep({ commit }, data = {}) {
    if (Object.keys(data).length) {
      commit('updateSignUpData', data)
    }
    commit('resetData')
  }
}
const mutations = {
  setStepSignUp(state, stepIndex) {
    if (stepIndex <= state.maxStepSignUp) {
      state.currentStepSignUp = stepIndex
    }
  },
  updateSignUpData(state, data) {
    state.signUpData = {
      ...data, ...state.signUpData
    }
  },
  nextStep(state) {
    if (localStorage.getItem('email') && localStorage.getItem('step1')) {
      // state.currentStepSignUp = 2
      localStorage.setItem('step2', JSON.stringify(state.signUpData))
    }
    if (localStorage.getItem('email')) {
      // state.currentStepSignUp = 2
      localStorage.setItem('step1', JSON.stringify(state.signUpData))
    } else {
      // state.currentStepSignUp = 3
      localStorage.setItem('email', JSON.stringify(state.signUpData))
    }
    // state.currentStepSignUp++
    // localStorage.setItem(state.currentStepSignUp, JSON.stringify(state.signUpData))
    if (state.maxStepSignUp < state.currentStepSignUp) {
      state.maxStepSignUp = state.currentStepSignUp
    }
  },
  resetData(state) {
    state.signUpData = {
      ...signUpDataDefault
    }
    state.currentStepSignUp = 0
    state.maxStepSignUp = 0
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
